// extracted by mini-css-extract-plugin
module.exports = {"screen":"Clients_screen__KKijX"};